import Dashboard from "@/common/components/layout/Dashboard";
import Toast from "@/common/components/ui/toast";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import ExclusionHistoryDetailsPage from "./ExclusionHistoryDetails.page";

export default function ExclusionHistoryDetailsRegisterPage() {
    return (
        <ToastProvider>
            <Dashboard>
                <ExclusionHistoryDetailsPage />
            </Dashboard>
            <Toast />
        </ToastProvider>
    );
}
